<template>
  <svg class='svg-icon' v-bind="{...iconMap.default, ...iconMap[icon], ...htmlAttrs, width, height}">

    <template v-if="icon === 'phone'">
      <path d="M9 0v48h30V0H9zm15 43.96a2 2 0 1 1 0-4 2 2 0 0 1 0 4zM35 15V36H13V4h22v11z" fill="#241F20" />
    </template>

    <template v-else-if="icon === 'email'">
      <path d="M10 12.47 0 3.65V15h20V3.65l-10 8.82Zm0-2.66L0 .98V0h20v.98L10 9.81Z" fill="#000" fill-rule="evenodd" />
    </template>

    <template v-else-if="icon === 'advisors'">
      <path d="M21 20.8c1.2.7 2 2 1.9 3.2 0 .8-.1.8-1.1 1a157.1 157.1 0 0 1-18.4 0c-1.4-.4-.6-3 1.2-4.1 1.4-1 4.3-2.3 5-2.5 1.1-.2 1.2-.8 0-3A9 9 0 0 1 9 12c0-2.4.5-4 2.6-4.9l1.3-.2c1.4 0 2.7.8 3.2 2 .8 1.5.5 5.6-.3 7-1 1.7-.9 2.2.2 2.5.7.2 2.8 1.2 5 2.4zm-17-1L2.5 21H.4c-.8-.2-.4-1.7.7-2.3.7-.5 2.3-1.3 2.8-1.4.5 0 .7-.4 0-1.6a4 4 0 0 1-.4-2c0-1.3.3-2.2 1.5-2.6a2 2 0 0 1 2.5.9c.4.9.2 3.1-.3 4-.5 1-.4 1.2.2 1.3l.7.3A35 35 0 0 0 4 19.8zm20.5-1.2c.7.4 1.1 1.1 1 1.8 0 .5 0 .5-.5.6h-1.8a41 41 0 0 0-5.7-3.4l.7-.3c.6 0 .7-.4 0-1.6-.1-.3-.3-1-.3-2 0-1.3.2-2.2 1.4-2.6 1-.4 2.1 0 2.5.9.4.9.3 3.1-.2 4-.5 1-.4 1.2.1 1.3l2.8 1.3z"/>
    </template>

    <template v-else-if="icon === 'award'">
      <path fill="#B9E4F2" d="M28 52a24 24 0 0 0 24-24C52 15 41 4 28 4A24 24 0 0 0 4 28a24 24 0 0 0 24 24Zm-9.4-11c-.5-.4-.6-1-.3-2l2.9-8.6-7.3-5.2c-.9-.6-1.2-1.2-1-1.9.2-.6.9-1 1.9-1l9 .1 2.7-8.6c.3-1 .8-1.5 1.5-1.5s1.2.6 1.5 1.5l2.7 8.6h9c1 0 1.6.3 1.9 1 .2.6-.1 1.2-1 1.8l-7.3 5.2 2.9 8.6c.3 1 .2 1.6-.3 2-.6.5-1.3.3-2.1-.3L28 35.4l-7.3 5.3c-.8.6-1.5.8-2 .4Z"/>
    </template>

    <template v-else-if="icon === 'house'">
      <path fill-rule="evenodd" clip-rule="evenodd" d="m7.9 0 7.6 6.9v9H.2V7L8 0Zm1.4 16v-5H6.5v5h2.8Z" fill="#005E74"/>
    </template>

  </svg>
</template>

<script>
export default {
  name: 'SVGLoader',
  props: {
    icon: {
      type: String,
      required: true
    },
    width: {
      type: Number,
      required: true
    },
    height: {
      type: Number,
      required: true
    },
    htmlAttrs: {
      type: Object,
      default: () => {}
    }
  },
  data: () => {
    return { iconMap: getIconMap() };
  }
}

function getIconMap() {
  return {
    default: {
      xmlns: 'http://www.w3.org/2000/svg'
    },
    phone: {
      viewBox: '0 0 48 48'
    },
    email: {
      viewBox: '0 -2.5 20 20'
    },
    advisors: {
      viewBox: '-3 0 32 32',
      fill: "#FFFFFF",
      stroke: "#FFFFFF",
      strokeWidth: 0.7
    },
    award: {
      viewBox: '0 0 56 56',
    },
    house: {
      viewBox: '0 0 16 16',
    }
  }
}
</script>

<style lang="scss" scoped>
</style>